interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: number | string;
}

export function StatCard({ icon, label, value }: StatCardProps) {
  return (
    <div className="rounded-2xl border border-line bg-surface-2 p-7">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-fg-tertiary">{label}</p>
          <p className="mt-2 text-display font-semibold text-fg">{value}</p>
        </div>
        <div className="flex size-12 items-center justify-center rounded-xl bg-brand-tint">{icon}</div>
      </div>
    </div>
  );
}
